export const MUTATION_GROUP = 'datePickerFields' as const;
